/*!
 * Binding provider for <!-- ko handler: ... --> virtual elements 🥊  tko.provider.virtual@4.0.0-alpha5c
 * (c) The Knockout.js Team - https://tko.io/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

import { virtualElements } from 'tko.utils';
import { BindingStringProvider } from 'tko.provider.bindingstring';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var VirtualProvider = /** @class */ (function (_super) {
    __extends(VirtualProvider, _super);
    function VirtualProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VirtualProvider.prototype, "FOR_NODE_TYPES", {
        get: function () { return [1, 8]; },
        enumerable: true,
        configurable: true
    });
    /**
     * Convert <ko binding='...'> into <!-- ko binding: ... -->
     * @param {HTMLElement} node
     */
    VirtualProvider.prototype.preprocessNode = function (node) {
        var e_1, _a;
        if (node.tagName === 'KO') {
            var parent_1 = node.parentNode;
            var childNodes = __spread(node.childNodes);
            var virtualBindingString = __spread(this.genElementBindingStrings(node)).join(',');
            var openNode = document.createComment('ko ' + virtualBindingString);
            var closeNode = document.createComment('/ko');
            parent_1.insertBefore(openNode, node);
            try {
                for (var childNodes_1 = __values(childNodes), childNodes_1_1 = childNodes_1.next(); !childNodes_1_1.done; childNodes_1_1 = childNodes_1.next()) {
                    var child = childNodes_1_1.value;
                    parent_1.insertBefore(child, node);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (childNodes_1_1 && !childNodes_1_1.done && (_a = childNodes_1["return"])) _a.call(childNodes_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            parent_1.insertBefore(closeNode, node);
            node.remove();
            return __spread([openNode], childNodes, [closeNode]);
        }
    };
    VirtualProvider.prototype.genElementBindingStrings = function (node) {
        var e_2, _a, _b, _c, _d, name_1, value, e_2_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 5, 6, 7]);
                    _b = __values(node.attributes), _c = _b.next();
                    _e.label = 1;
                case 1:
                    if (!!_c.done) return [3 /*break*/, 4];
                    _d = _c.value, name_1 = _d.name, value = _d.value;
                    return [4 /*yield*/, name_1.replace(/^ko-/, '') + ": " + value];
                case 2:
                    _e.sent();
                    _e.label = 3;
                case 3:
                    _c = _b.next();
                    return [3 /*break*/, 1];
                case 4: return [3 /*break*/, 7];
                case 5:
                    e_2_1 = _e.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 7];
                case 6:
                    try {
                        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    };
    VirtualProvider.prototype.getBindingString = function (node) {
        if (node.nodeType === document.COMMENT_NODE) {
            return virtualElements.virtualNodeBindingValue(node);
        }
    };
    VirtualProvider.prototype.nodeHasBindings = function (node) {
        if (node.nodeType === document.COMMENT_NODE) {
            return virtualElements.isStartComment(node);
        }
    };
    return VirtualProvider;
}(BindingStringProvider));

export { VirtualProvider };
//# sourceMappingURL=tko.provider.virtual.js.map
